module.exports = __webpack_public_path__ + "img/star.f10f4b72.png";